// teams/actionTypes.js
const REQUEST_TEAMS = '@@teams/REQUEST_TEAMS';
const TEAMS_RESPONSE = '@@teams/TEAMS_RESPONSE';
const REQUEST_GAMES_FOR_TEAM = '@@teams/REQUEST_GAMES_FOR_TEAM';
const GAMES_FOR_TEAM_RESPONSE = '@@teams/GAMES_FOR_TEAM_RESPONSE';
const REQUEST_LOGO_ASSETS = '@@teams/REQUEST_LOGO_ASSETS';
const LOGO_ASSETS_RESPONSE = '@@teams/LOGO_ASSETS_RESPONSE';
const REQUEST_TEAM_SOCIAL_ACCOUNTS = '@@teams/REQUEST_TEAM_SOCIAL_ACCOUNTS';
const TEAM_SOCIAL_ACCOUNTS_RESPONSE = '@@teams/TEAM_SOCIAL_ACCOUNTS_RESPONSE';
const REQUEST_GAME_NOTES = '@@teams/REQUEST_GAME_NOTES';
const GAME_NOTES_RESPONSE = '@@teams/GAME_NOTES_RESPONSE';

export default {
    REQUEST_TEAMS,
    TEAMS_RESPONSE,
    REQUEST_GAMES_FOR_TEAM,
    GAMES_FOR_TEAM_RESPONSE,
    REQUEST_LOGO_ASSETS,
    LOGO_ASSETS_RESPONSE,
    REQUEST_TEAM_SOCIAL_ACCOUNTS,
    TEAM_SOCIAL_ACCOUNTS_RESPONSE,
    REQUEST_GAME_NOTES,
    GAME_NOTES_RESPONSE
}